<div class="students-batch-create" (paste)="onPaste($event)">
  <lms-toolbar [options]="toolbarConfig">
    <div class="lms-toolbar__item padding-none" left>
      <gl-checkbox
        *ngIf="group"
        id="reEnrolled"
        small
        [label]="'students.import.reEnrolledLabel' | translate"
        skeletorValueAccessor
        checked
        [(ngModel)]="hasToReEnroll"
      >
      </gl-checkbox>
      <gl-tooltip
        *ngIf="tooltipText"
        class="lms-toolbar__item padding-right"
        medium
        posBottom
        [text]="tooltipText"
      ></gl-tooltip>
    </div>
    <div class="lms-toolbar__item">
      <gl-button
        icon
        icon-center="glicon-plus"
        tooltipCenter
        headerColor
        [tooltip]="'actions.addStudents' | translate"
        (onClick)="addEmptyRow()"
      ></gl-button>
    </div>
    <div class="lms-toolbar__item">
      <gl-button
        color-primary
        [text]="'actions.addStudents' | translate"
        [disabled]="hasTableErrors"
        (onClick)="onSubmit()"
      >
      </gl-button>
    </div>
  </lms-toolbar>
  <div class="header-content">
    <gl-table-header [columns]="dataSource.columns"></gl-table-header>
  </div>
  <div class="activation-table">
    <gl-table id="studentsCreationListId" [dataSource]="dataSource" data-testid="studentsCreationList">
      <span slot="header"></span>
      <div class="placeholder" slot="placeholder"></div>
    </gl-table>
  </div>
</div>
